import * as actionTypes from "./actionTypes";

export const setSecurityChangeRequest = request => {
  return {
    type: actionTypes.SET_SECURITY_CHANGE_REQUEST,
    securityChangeRequest: request
  };
};
